
const validPositions = [
  'bottom-center',
  'bottom-left',
  'bottom-right',
  'center',
  'top-center',
  'top-left',
  'top-right',
];

export const toastProps = {
  autoZIndex:        { type: Boolean,  default: true },
  baseZIndex:        { type: Number,   default: 0 },
  breakpoints:       { type: Object,   default: null },
  closeIcon:         { type: Boolean,  default: undefined },
  conentIcon:        { type: Boolean,  default: false },
  group:             { type: String,   default: null },
  messageIcon:       { type: Boolean,  default: false },
  onClick:           { type: Function, default: undefined },
  onMouseEnter:      { type: Function, default: undefined },
  onMouseLeave:      { type: Function, default: undefined },
  position:          { type: String,   default: 'top-right', validator: x => validPositions.includes(x) },
  unstyled:          { type: Boolean,  default: false },
};
